import { faToolbox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import mixpanel from "mixpanel-browser";

import { AccountItem, AccountItemLine } from "./AccountItem.js";
import DarkModeToggle from "./DarkModeToggle.js";
import { useLocalStorage } from "../../hooks/use-local-storage.js";
import ToggleSwitch from "../common/buttons/ToggleSwitch";

export default function PreferencesSettings() {
  return (
    <div id="preferences">
      <AccountItem
        title="Preferences"
        icon={
          <FontAwesomeIcon icon={faToolbox} size="lg" color="gray" />
        }
      >
        <div className="flex flex-col flex-1 w-full space-y-4 divide-y dark:divide-gray-700">
          <AccountItemLine>
            <div className="dark:text-gray-300 text-xs md:text-sm lg:w-96 mr-4">
              <strong>Appearance:</strong> Using Scribenote late at
              night? Turn on dark mode and your eyes will thank you!
              👀
            </div>
            <DarkModeToggle />
          </AccountItemLine>
          <AccountItemLine>
            <div className="dark:text-gray-300 text-xs md:text-sm lg:w-96 mr-4">
              <strong>Capitalize SOAP Titles:</strong> When you copy
              an entire SOAP, this setting will determine if the S, O,
              A, and P titles are capitalized for readability.
            </div>
            <CapitalFormatToggle />
          </AccountItemLine>

          <AccountItemLine>
            <div className="dark:text-gray-300 text-xs md:text-sm lg:w-96 mr-4">
              <strong>Copy Note on Submit:</strong> Turning this
              setting on will automatically copy the note to your
              clipboard when you submit it.
            </div>
            <CopySubmitToggle />
          </AccountItemLine>
        </div>
      </AccountItem>
    </div>
  );
}

function CapitalFormatToggle() {
  const [
    shouldUseCapitalSubtitlesCopy,
    setShouldUseCapitalSubtitlesCopy,
  ] = useLocalStorage("should-use-capital-subtitles-copy");

  return (
    <div className="flex flex-row items-center space-x-2 mx-2 cursor-pointer">
      <p className="text-sm">Don't Capitalize</p>
      <ToggleSwitch
        toggleState={shouldUseCapitalSubtitlesCopy}
        setToggleState={setShouldUseCapitalSubtitlesCopy}
        toggleCallback={() => {
          mixpanel.track("Updated Account Setting", {
            settingName: "Capitalize SOAP titles",
            settingKey: "should-use-capital-subtitles-copy",
            settingValue: !shouldUseCapitalSubtitlesCopy,
          });
        }}
      />
      <p className="text-sm">Capitalize</p>
    </div>
  );
}

function CopySubmitToggle() {
  const [shouldCopyOnSubmit, setShouldCopyOnSubmit] = useLocalStorage(
    "should-copy-on-submit",
    true,
  );

  return (
    <div className="flex flex-row items-center space-x-2 mx-2 cursor-pointer">
      <p className="text-sm">Don't Copy</p>
      <ToggleSwitch
        toggleState={shouldCopyOnSubmit}
        setToggleState={setShouldCopyOnSubmit}
        toggleCallback={() => {
          mixpanel.track("Updated Account Setting", {
            settingName: "Copy Note On Submit",
            settingKey: "should-copy-on-submit",
            settingValue: !shouldCopyOnSubmit,
          });
        }}
      />
      <p className="text-sm">Copy</p>
    </div>
  );
}
